'use client';

import { useEffect } from 'react';
import { isTwaContext } from '@/lib/twa-detection';

// Persists the TWA flag into sessionStorage on the very first page the
// Android app renders (while ?twa=1 / the android-app:// referrer is still
// present), so the Google Play billing gate holds across later client-side
// navigations that no longer carry the signal. Renders nothing.
export default function TwaContextSeeder() {
  useEffect(() => {
    isTwaContext();
  }, []);
  return null;
}
